/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import * as Types from '../../../../types/schema.generated';

import gql from 'graphql-tag';
import * as VueApolloComposable from '@vue/apollo-composable';
import * as VueCompositionApi from 'vue';
export type ReactiveFunction<TParam> = () => TParam;
export type FetchCalendarDetailForCheckQueryVariables = Exact<{
  guid: string | number;
}>;


export type FetchCalendarDetailForCheckQuery = { calendarDetail:
    | { __typename: 'CalendarDetailNotFound', message: string }
    | { __typename: 'CalendarDetailPermissionDenied' }
    | { __typename: 'CalendarDetailSuccess', calendar: { privateTitle: string | null, publicTitle: string } }
   };

export type NextBookWithCalendarByEntranceFromModalMutationVariables = Exact<{
  calendarGUID: string | number;
  previousBookingGUID: string | number;
  startsAt: TimeString;
  endsAt: TimeString;
}>;


export type NextBookWithCalendarByEntranceFromModalMutation = { bookWithCalendarByEntrance:
    | { message: string }
    | { unit: any }
    | Record<PropertyKey, never>
   | null };


export const FetchCalendarDetailForCheckDocument = gql`
    query FetchCalendarDetailForCheck($guid: ID!) {
  calendarDetail(guid: $guid) {
    __typename
    ... on CalendarDetailSuccess {
      calendar {
        privateTitle
        publicTitle
      }
    }
    ... on CalendarDetailNotFound {
      message
    }
  }
}
    `;

/**
 * __useFetchCalendarDetailForCheckQuery__
 *
 * To run a query within a Vue component, call `useFetchCalendarDetailForCheckQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchCalendarDetailForCheckQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useFetchCalendarDetailForCheckQuery({
 *   guid: // value for 'guid'
 * });
 */
export function useFetchCalendarDetailForCheckQuery(variables: FetchCalendarDetailForCheckQueryVariables | VueCompositionApi.Ref<FetchCalendarDetailForCheckQueryVariables> | ReactiveFunction<FetchCalendarDetailForCheckQueryVariables>, options: VueApolloComposable.UseQueryOptions<FetchCalendarDetailForCheckQuery, FetchCalendarDetailForCheckQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<FetchCalendarDetailForCheckQuery, FetchCalendarDetailForCheckQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<FetchCalendarDetailForCheckQuery, FetchCalendarDetailForCheckQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<FetchCalendarDetailForCheckQuery, FetchCalendarDetailForCheckQueryVariables>(FetchCalendarDetailForCheckDocument, variables, options);
}
export function useFetchCalendarDetailForCheckLazyQuery(variables?: FetchCalendarDetailForCheckQueryVariables | VueCompositionApi.Ref<FetchCalendarDetailForCheckQueryVariables> | ReactiveFunction<FetchCalendarDetailForCheckQueryVariables>, options: VueApolloComposable.UseQueryOptions<FetchCalendarDetailForCheckQuery, FetchCalendarDetailForCheckQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<FetchCalendarDetailForCheckQuery, FetchCalendarDetailForCheckQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<FetchCalendarDetailForCheckQuery, FetchCalendarDetailForCheckQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<FetchCalendarDetailForCheckQuery, FetchCalendarDetailForCheckQueryVariables>(FetchCalendarDetailForCheckDocument, variables, options);
}
export type FetchCalendarDetailForCheckQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<FetchCalendarDetailForCheckQuery, FetchCalendarDetailForCheckQueryVariables>;
export const NextBookWithCalendarByEntranceFromModalDocument = gql`
    mutation NextBookWithCalendarByEntranceFromModal($calendarGUID: ID!, $previousBookingGUID: ID!, $startsAt: Time!, $endsAt: Time!) {
  bookWithCalendarByEntrance(
    calendarGUID: $calendarGUID
    previousBookingGUID: $previousBookingGUID
    startsAt: $startsAt
    endsAt: $endsAt
  ) {
    ... on BookWithCalendarByEntranceSuccess {
      unit
    }
    ... on BookWithCalendarByEntranceErrorAlreadyReserved {
      message
    }
  }
}
    `;

/**
 * __useNextBookWithCalendarByEntranceFromModalMutation__
 *
 * To run a mutation, you first call `useNextBookWithCalendarByEntranceFromModalMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useNextBookWithCalendarByEntranceFromModalMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useNextBookWithCalendarByEntranceFromModalMutation({
 *   variables: {
 *     calendarGUID: // value for 'calendarGUID'
 *     previousBookingGUID: // value for 'previousBookingGUID'
 *     startsAt: // value for 'startsAt'
 *     endsAt: // value for 'endsAt'
 *   },
 * });
 */
export function useNextBookWithCalendarByEntranceFromModalMutation(options: VueApolloComposable.UseMutationOptions<NextBookWithCalendarByEntranceFromModalMutation, NextBookWithCalendarByEntranceFromModalMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<NextBookWithCalendarByEntranceFromModalMutation, NextBookWithCalendarByEntranceFromModalMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<NextBookWithCalendarByEntranceFromModalMutation, NextBookWithCalendarByEntranceFromModalMutationVariables>(NextBookWithCalendarByEntranceFromModalDocument, options);
}
export type NextBookWithCalendarByEntranceFromModalMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<NextBookWithCalendarByEntranceFromModalMutation, NextBookWithCalendarByEntranceFromModalMutationVariables>;